import { IconType } from 'react-icons';
import { FiBook, FiBookOpen, FiClock, FiGitBranch, FiGitMerge, FiSettings, FiShield, FiUpload } from 'react-icons/fi';

export const API_HTTP_METHODS = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'] as const;

export const API_LIFECYCLE_STATUSES = ['stable', 'beta', 'deprecated'] as const;

export const API_CATALOG_VERSIONS = ['v1', 'v2'] as const;

export const GROUP_ICON_OPTIONS: { value: string; label: string; icon: IconType }[] = [
    { value: 'shield', label: 'Shield', icon: FiShield },
    { value: 'upload', label: 'Upload', icon: FiUpload },
    { value: 'git-branch', label: 'Git Branch', icon: FiGitBranch },
    { value: 'workflow', label: 'Workflow', icon: FiGitMerge },
    { value: 'clock', label: 'Clock', icon: FiClock },
    { value: 'settings', label: 'Settings', icon: FiSettings },
    { value: 'book-open', label: 'Book', icon: FiBookOpen },
];

export const DEFAULT_GROUP_ICON = 'workflow';

/*
 * Maps a catalog group's backend `icon` key to the react-icons component used to render it.
 */
export const CATALOG_GROUP_ICON_MAP: Record<string, IconType> = GROUP_ICON_OPTIONS.reduce(
    (acc, option) => ({ ...acc, [option.value]: option.icon }),
    {} as Record<string, IconType>,
);

export const CATALOG_GROUP_FALLBACK_ICON: IconType = FiBook;

/*
 * Domain suffix used to build the auto-provisioned service-principal DataStudio username.
 */
export const SERVICE_PRINCIPAL_DOMAIN = 'deepiq.com';

/*
 * HTTP methods that accept a request body in the Try It Out console.
 */
export const METHODS_WITH_BODY = ['POST', 'PUT', 'PATCH'];

/*
 * Path-prefix rules for Try It Out — resolves which backend service an endpoint
 * actually lives behind, based on its catalog `endpointKey`, since the catalog's
 * documented `path` alone does not include the service segment the gateway needs.
 */
export const API_PORTAL_TRY_IT_OUT_PREFIXES = {
    asset: '/asset',
    airflowCreate: '/airflow/api',
    databricksJob: '/databricks/api',
    databrowserPanel: '/databrowser/api',
    platformGet: '/platform/api',
} as const;

export const API_MANAGEMENT_TABS = {
    groups: 'groups',
    endpoints: 'endpoints',
} as const;

/*
 * Destination for the "Examples / Docs" link on the catalog detail header.
 */
export const API_EXAMPLES_DOCS_URL = 'https://curl.se/docs/';
